    <cradua-application
    [applications]="applications$ | async"
    [roles]="roles$ | async"
    (submitEvent)="onSubmit($event)"
    (emitAssignedRole)="onEmitAssignedRole($event)"
    (deleteapplicationEvent)="onDeleteapplication($event)"
    *ngIf="(isLoading$ | async ) === false || (isLoadingRole$ | async ) === false"
    >
</cradua-application>

<mrsoftapps-epims-reference-spinner

*ngIf="(isLoading$ | async) === true && (isLoadingRole$ | async ) === true"
>
</mrsoftapps-epims-reference-spinner>

